import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Printer } from "lucide-react";
import { http, formatApiError } from "@/lib/api";
import { WordStars } from "@/components/parent/KidWords";

export default function PracticeList() {
  const { studentId } = useParams();
  const [d, setD] = useState(null);
  const [name, setName] = useState("");
  const [err, setErr] = useState(null);
  useEffect(() => {
    http.get(`/students/${studentId}/words`).then((r) => setD(r.data)).catch((e) => setErr(formatApiError(e)));
    http.get("/family/children").then((r) => setName(r.data.find((k) => k.id === studentId)?.name || "")).catch(() => {});
  }, [studentId]);
  if (err) return <p className="max-w-3xl mx-auto px-6 py-16 text-[#C87D53]" data-testid="practice-error">{err}</p>;
  if (!d) return <p className="max-w-3xl mx-auto px-6 py-16 text-stone-500">Loading…</p>;
  const order = [...d.words].sort((a, b) => (a.mastered + a.spell_mastered) - (b.mastered + b.spell_mastered));
  return (
    <div className="max-w-3xl mx-auto px-6 py-12 pb-24 print:py-0" data-testid="practice-page">
      <div className="flex flex-wrap items-end gap-4">
        <div className="flex-1">
          <span className="text-xs font-semibold uppercase tracking-[0.25em] text-[#C87D53]">Practice together</span>
          <h1 className="font-display text-4xl sm:text-5xl text-[#2C4A3E] mt-2">{name ? `${name.split(" ")[0]}'s` : "My"} word list</h1>
          <p className="mt-2 text-sm text-stone-600">Read each word aloud, talk about what it means, then try spelling it on the line. Words still being learned come first.</p>
        </div>
        <button onClick={() => window.print()} data-testid="practice-print-btn" className="print:hidden inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#2C4A3E] text-white text-sm"><Printer className="w-4 h-4" /> Print</button>
      </div>
      <ol className="mt-8 space-y-4" data-testid="practice-list">
        {order.map((w, i) => (
          <li key={w.id} className="break-inside-avoid border-b border-[#E6DEC3] pb-4" data-testid={`practice-word-${w.id}`}>
            <p className="font-display text-2xl text-[#2C4A3E]">{i + 1}. {w.syllables} <WordStars w={w} /></p>
            <p className="text-stone-700 mt-1">{w.meaning}</p>
            {w.example && <p className="text-sm text-stone-500 italic mt-1">“{w.example}”</p>}
            <p className="mt-3 text-sm text-stone-500">Spell it: <span className="inline-block w-56 border-b border-stone-400 align-bottom" /></p>
          </li>
        ))}
      </ol>
      {!order.length && <p className="text-stone-500 mt-8">No saved words yet.</p>}
    </div>
  );
}
